"use client";

// Locale is a client preference (cookie + account session), not a URL segment.
// Switching applies in place - no navigation - so the language sticks on every
// route, including 404s and unknown paths.

import { startTransition } from "react";
import { useRouter } from "next/navigation";
import { useLocaleStore, setStoredLocale } from "./locale-store";
import type { Locale } from "./config";

export function useClientLocale(): Locale {
  return useLocaleStore();
}

/** Change language in place: update the store, then re-render for fresh English. */
export function useSetLocale() {
  const router = useRouter();
  return (locale: Locale) => {
    setStoredLocale(locale);
    // The DOM translator can only translate FROM English, so refresh the server
    // components to reset text to English before translating into the new locale.
    startTransition(() => router.refresh());
  };
}
